import React, { useState, useEffect } from 'react';
import axios from 'axios';

// sets up interceptor for handling auth
import './api/setup';

interface AuthedAppProps {
    children: React.ReactNode;
}

export const AuthedApp = ({ children }: AuthedAppProps): React.ReactElement | null => {
    const [authed, setAuthed] = useState(false);

    useEffect(() => {
        axios.get('/api/v1/auth').then(() => setAuthed(true));
    }, []);

    return authed ? <>{children}</> : null;
};
